export const EscapeElement = ({color, translateY, translateX, rotate, absolute}) => {
    const styles = {
        backgroundColor: color,
        transform: `rotate(${rotate})`,
    };
    const stylesBlock = {
        position: absolute ? absolute : 'static',
        transform: `rotate(${rotate})`,
    }
    return (
        <button style={stylesBlock} className="right-0 top-[10px] w-[40px] h-[40px]">
            <span style={styles} className={`translate-y-[${translateY}] translate-x-[${translateX}] ]` + " absolute top-[50%] left-0 w-[27px] h-[2px] rounded"}></span>
            <span style={{...styles, transform: `rotate(-${rotate})`}} className={`translate-y-[${translateY}] translate-x-[${translateX}]]` + " absolute top-[50%] left-0 w-[27px] h-[2px] rounded"}></span>
        </button>
    );
}